// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__N28pZ","title":"Header_title__1onps","side":"Header_side__1_LNJ"};